export { default as LookupList } from './LookupList';
export { default as LookupEdit } from './LookupEdit';



// WEBPACK FOOTER //
// ./src/modules/lookup/pages/index.js